import cx from "classnames";
import { Icon } from "common/Icon";
import React from "react";
import { RouteDialogContainer } from "./RouteDialog";
import styles from "./RouteRow.scss";

export class RouteRow extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showEdit: false,
    };
  }

  onClick = (e) => {
    e.preventDefault();
    this.showEdit();
  };

  showEdit = () => {
    this.setState({ showEdit: true });
  };

  hideEdit = () => {
    this.setState({ showEdit: false });
  };

  render() {
    const { id, name, color, customColor, url } = this.props;
    const { showEdit } = this.state;

    return (
      <div className={styles.RouteRow}>
        <div className={cx(styles.row, styles.routeName)}>{name}</div>
        <div className={styles.row}>
          <div className={styles.routeColor}>
            <span className={styles.Color}>
              <div style={{ backgroundColor: color }} className={styles.ColorSample} />
              {customColor ? "custom" : "auto"}
            </span>
          </div>
          <div className={styles.routeUrl}>
            <span data-tip={url} title={url}>
              <Icon i="md-link" size={18} /> {url ? "custom" : "auto"}
            </span>
          </div>
          <div className={styles.routeEdit}>
            <a href="#" onClick={this.onClick}>
              Edit
            </a>
          </div>
        </div>
        {showEdit && (
          <RouteDialogContainer
            name={name}
            color={color}
            customColor={customColor}
            url={url}
            routeId={id}
            onCancel={this.hideEdit}
            onRequestClose={this.hideEdit}
          />
        )}
      </div>
    );
  }
}
